/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // Import

/**
 * Internal dependencies
 */
import { getLayoutId } from "state/dashboard/selectors";
import { startEditing } from "state/ui/dashboard-form/actions";
import { deleteDashboard } from "state/dashboard/actions";

import DeleteConfirmPrompt from "./delete-confirm-prompt"; // has to be own component otherwise state wont change
import SetDefaultPrompt from "./set-default-prompt"; // has to be own component otherwise state wont change
import { savePreference } from "state/preferences/actions";
import vd from "lib/vd";
import { successNotice } from "state/notices/actions";
import { DropdownLinkV2 } from "components/dropdown-link-v2";
/**
 * Style dependencies
 */
import "./styles.scss";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const DashboardActions = ({ dashboardId, ...props }) => {
  const confirmDefault = (dashboardId) => {
    confirmAlert({
      title: "Set default deck",
      message: "Are you sure you want to make this your default deck?",
      customUI: (p) => (
        <SetDefaultPrompt
          dashboardId={dashboardId}
          savePreference={props.savePreference}
          {...p}
        />
      ),
    });
  };

  const deleteDashboard = (dashboardId) => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure to delete this deck?",
      customUI: (p) => (
        <DeleteConfirmPrompt
          dashboardId={dashboardId}
          deleteDashboard={props.deleteDashboard}
          {...p}
        />
      ),
    });
  };

  const handleOnRefresh = () => {
    vd.cubeJs()
      .triggerPreAggregations()
      .then((res) => {
        props.successNotice(
          "Deck data queued for refresh. Please wait 10 minutes."
        );
      })
      .catch((e) => {
        console.error(e);
      });
  };

  let items = [
    {
      key: "edit",
      label: "Edit deck",
      onClick: () => props.startEditing(dashboardId),
      align: "left",
    },
    {
      key: "default",
      label: "Set as default",
      onClick: () => confirmDefault(dashboardId),
      align: "left",
    },
    {
      key: "refresh",
      label: "Refresh deck data",
      onClick: handleOnRefresh,
      align: "left",
    },
    {
      key: "delete",
      label: "Delete deck",
      onClick: () => deleteDashboard(dashboardId),
      align: "left",
    },
  ];

  return (
    <DropdownLinkV2
      activatorProps={{ compact: true }}
      label="Actions"
      items={items}
    />
  );
};

export default connect(
  (state) => ({
    dashboardId: getLayoutId(state),
  }),
  { startEditing, deleteDashboard, savePreference, successNotice }
)(DashboardActions);
